const coversModel = {
  "8fd48299a3e1881802b8319b1b6aa3b9": {     // Αστική Ευθύνη
    "07977d126cad7a981c23af82d51a87c4": {   // Α.Ε. σε φυλασσόμενο χώρο (Σ.Β.)
      "hideFromView": true
    },
    "c8893857fa6d378f4ee93a7e707f72d2": {   // Α.Ε. σε φυλασσόμενο χώρο (Υ.Ζ.)
      "hideFromView": true
    },
    "217410302b56f58079d79d0388e6daca": {   // Αστική Ευθύνη Πυρός
      "hideFromView": true
    },
    "70e5d4f0e66c3fff5218ab470d05116f": {}, // Αστική Ευθύνη Σωματικές Βλάβες
    "fd25e8f4c911ee83469a061e04948106": {}, // Αστική Ευθύνη Υλικές Ζημιές
    "6b4f0a58b5a85173e13c4b56652648d3": {   // Α.Ε. από Διαρροή Υγρών (Σ.Β)
      "hideFromView": true
    },
    "20cfe5733849ad1149faec56b20c4d94": {   // Αστική Ευθύνη κατά τη Μεταφορά
      "hideFromView": true
    },
    "e814ed3c09646ef4738ddc691db72d66": {   // Α.Ε. από Διαρροή Υγρών (Υ.Ζ)
      "hideFromView": true
    },
    "7cd1111642086b9918252b792d6f400a": {   // Α.Ε. κλέπτου
      "hideFromView": true
    },
    "1f2ec7b826f4d4a6a94a307026ae564e": {   // Αστική Ευθύνη μεταφερόμενου φορτίου
      "hideFromView": true
    },
    "7d030c3929385d9c596fc2381b3252c3": {}, // Σωματικές Βλάβες ανά άτομο
    "441ce8cf78cc0eec096bdef36f970843": {}, // Σωματικές Βλάβες ανά συμβάν
    "5cdfa715120fe65d2a42a8a628baf95f": {}, // Ανώτατο όριο ευθύνης
    "AE_APO_METADOSOI_PYRKAGIAS_SB": {
      "hideFromView": true
    },
    "KALYPSI_DIASTAYROUMENHS_ASTIKES_EYTHINIS": {
      "hideFromView": true
    },
  },
  "d3a30830007416b372d74aa707a791d7": {     // Φροντίδα ατυχήματος
    "3eec760eb80c32d803ababbea2743c3b": {}, // Ρυμούλκηση συνεπεία ατυχήματος
  },
  "f57b212f2f5b7e47c2218856e0ec4b1e": {},   // Ζημιές από ανασφάλιστο όχημα
  "ff976a89368d5736e0fc990cf5bb1a02": {},    // Προστασία Β/Μ
  "01008763721c65cd640af27ce18b0365": {     // Πυρός
    "9aece553e287e92cb1c2c4e3f2476814": {}, // Πυρκαγιά από Δάσος
    "a56fea34f9ae6dc9651776fab46cd38e": {}, // Καπνός
    "50a2771c31fb34f31e72b344d394a48f": {}, // Ζημιές πυρόσβεσης
    "bc84abb22b2e4a4751f7ddb148780ac3": {}  // Έξοδα πυρόσβεσης
  },
  "97922a4285646742aca839a700add2f4": {     // Πυρός
    "126ea289b07e17f4a742d516ec6f7630": {}, // Πολιτικές Ταραχές
    "e75cf8d1761ddea8fbf6eb1a83346165": {}, // Στάσεις/Απεργίες
    "0e0d36119121a16c5df905f898d1d184": {}, // Πυρός από Τρομοκρατικές Ενέργειες
    "125557f68aea7da008bb18df025b095c": {}, // Πυρός από Κακόβουλες Ενέργειες
    "8a29fc7ff834927440f4456ee9475f99": {}, // Μετάδοση πυρκαγιάς από εμπρησμό
    "9aece553e287e92cb1c2c4e3f2476814": {}, // Πυρκαγιά από Δάσος
    "a56fea34f9ae6dc9651776fab46cd38e": {}, // Καπνός
    "bc84abb22b2e4a4751f7ddb148780ac3": {}  // Έξοδα πυρόσβεσης
  },
  "87e4e58a68b99439a046d43777e54798": {},   // Ολική Κλοπή
  "0946f5c3ab061145147e2c5f94d3a933": {     // Μερική Κλοπή
    "a0fb838258010f97486713aeedbb757a": {}, // Κλοπή Ηχοσυστήματος
    "953e429b5b059b88a337aeb2335c479f": {}, // Αντικατάσταση Κατεστραμμένων Κλειδαριών
    "e2bb8c9aee381b8c505ba0cf3d073659": {}, // Αντικατάσταση Κλειδιών
    "2bc203971cc4931a584be7a6e5bc1ae0": {}, // Ίδιες Ζημίες από κλοπή
    "f6a9ce68adec97b876f2f18e9cf72268": {}, // Κλοπή τηλεφώνου
    "bc3893448629c492d291f587bda62a69": {}, // Κλοπή Συστήματος Πλοήγησης GPS
    "feb6517a44b2e434c877910ac4d0d972": {}, // Κλοπή air condition
    "332216b55bc11086df88c581d21a77d4": {}, // Ζημιές κατά την κλοπή
    "YLIKES_ZHMIES_KATA_APOPEIRA_KLOPHS": {}
  },
  "ec0aa33177ee6f89e2744928148e9217": {     // Φυσικά φαινόμενα
    "662f3c11b81157d3c636a29d579a9d7b": {}, // Ζημιές από Χαλάζι
    "3f71b74e46c0dbf01794e5e2f5b12978": {}, // Έκρηξη ηφαιστείου
    "2ce682b87f8808735b23a1e95cca2054": {}, // Ζημιές από Χιόνι
    "619e9ed0b60332128f6efa04527f5f95": {}, // Σεισμός
    "3900b6b5df25269109b8c0e6ed237a1c": {}, // Πλημμύρα, Θύελλα, Καταιγίδα
    "070550bf81049f8d680e914d80f10d89": {},
    "66f6e497baac31bed301894c0e73a24f": {},
    "5b0f2d9006524e50710e947e415aacd9": {},
  },
  "f0d7ca574ef0bef07eb77f55424e7ad1": {      // Ενοικίαση/Αντικατάσταση αυτοκινήτου
    "84a5a446fd98b7cf6c7e9f0f16929b98": {},  // Ενοικίαση/Αντικατάσταση οχήματος εξαιτίας πυρκαγιάς
    "1c3bca197119551030efffcfa220fe0e": {},  // Ενοικίαση/Αντικατάσταση οχήματος εξαιτίας μερικής κλοπής
    "d4b1889865ab4d5b02660404df5ac9c6": {},  // Ενοικίαση/Αντικατάσταση οχήματος εξαιτίας τροχαίου
    "6cf4802d902e63ab8d1e83bb27d8e979": {},  // Ενοικίαση/Αντικατάσταση οχήματος εξαιτίας ολικής κλοπής
    "2eba13a5f83ad7425dc0d1c116fd8308": {},  // Ενοικίαση/Αντικατάσταση οχήματος εξαιτίας φυσ.φαινομένων
    "38b93b96a81a7a4f79cbb8dda94a2199": {},  // Ενοικίαση/Αντικατάσταση οχήματος εξαιτίας ίδιων ζημιών
    "bd2e7ab577cf595699467c5e2fa91d66": {},  // Ενοικίαση/Αντικατάσταση οχήματος εξαιτίας κακόβουλων
    "ENOIKIASH/ANTIKATASTASH_OXHMATOS_EJAITIAS_TROMOKRATIKWN": {}
  },
  "b1ada174c523d553c94c6e820af2b484": {     // Ίδιες Ζημίες
    "1c0aca3a402fda2b8c6848527160dc24": {}, // Κακόβουλες Ενέργειες
    "92f3839322418816ee8b26f8b8d3e986": {}  // Ζημιές κατά τη μεταφορά
  },
  "2c8ce1fb6646495ba1d15c5c81bad1b3": {},   // Οδική βοήθεια
  "0f94adc0be6c83f1ce45136263186e60": {     // Νομική Προστασία
    "b9fad15277bf763df65e98523a7b09c4": {}, // Διεκδίκηση αξιώσεων αποζημίωσης έπειτα από σύγκρουση
    "faad9e23c000266b7c6a0827e3736da8": {}, // Υπεράσπιση σε ποινικά δικαστήρια λόγω θανάτωσης ή τραυματισμού απο τροχαίο.
    "28f536f83ca8c2eb496f9eb52f9c4d81": {}  // Διεκδίκηση αξιώσεων αποζημίωσης σύμφωνα με διατάξεις νόμων περί αστικής ευθύνης
  },
  "038ad68424a299dcc08ae6fe66e6cff3": {      // Θραύση κρυστάλλων
    "5a948af75a76d38fa33eeb3e005c005a": {},  // Ηλιοροφή
    "eb91def59bcbefac8a0f5363063f07d3": {}   // Μεμβράνες/αισθητήρες βροχής
  },
  "5a4969f8d917e3d1c3c3733dd331fcd8": {},   // Θραύση κρυστάλλων
  "af241d6ca0fb0a4386e5f20e67d016f0": {      // Προσωπικό Ατύχημα
    "4d0d65a0dc67d6200d7bc36c8bb7de88": {},  // Θάνατος
    "2a1ebc4fdb6d5af370faad41057299f6": {},  // Μόνιμη Ολική Ανικανότητα
    "162a1f8807cc72a892ba8a2ff7f3eeb3": {},  // Μόνιμη Μερική Ανικανότητα
    "0592e4a36afd78dcf85d516c776445af": {},  // Ιατροφαρμακευτικά Έξοδα
    "0054abe7c9e2c541845816ac894a2bbb": {}   // Νοσοκομειακή Περίθαλψη
  },
  "SYMMETOXH": {},
  "KEFALAIO_KALYPSHS": {},
  "IATRIKES_EPISKEPSEIS": {
    "poluatreia_diagnostika": {},
    "exoterika_iatria_klinik": {},
    "idiotika_iatria": {},
    "prosopikos_iatros": {}
  },
  "POSOSTO_KALYPSHS": {},
  "DIAGNWSTIKES_EKSETASEIS_SUB": {},
  "THESH_NOSHLEIAS": {
    "POINIKH_NOMIKH_PROSTASIA": {},
    "0166175e2974db6d93f763a929674aa5": {},  // Σεισμός
    "72d27edb1a38df3f4edc427ff0c4a7b8": {}   // Κακόβουλες Ενέργειες Σπίτι
  },
  "ARITHMOS_KALYPSEWN_NOSOKOMEIAKOU_PROGRAMMATOS": {},
  "c6bebf83d5ad3e5ce618948dc240e09f": {},   // Επείγουσα Μεταφορά
  "862b8eac9b4aaad631cdb30f3c9f03ca": {},   // Στάσεις,Απεργίες,Οχλαγωγίες,Πολιτικές ταραχές
  "292fd59297bcdebb7655faf8f37b560b": {     // Κλοπή Περιεχομένου
    "ca4168830966c284bd7c19dd5b863405": {}, // Ζημιές Περιεχομένου
    "KLOPH_KOSMHMATWN": {}
  },
  "6e45c63cd175b477309339671a758c9f": {},   // Τρομοκρατικές Ενέργειες
  "24c0e972659b54116856b2b15ad42efb": {     // Διάρρηξη Σωληνώσεων
    "3ce219e11eb092260257a296cef5ab93": {}, // Έξοδα άντλησης νερών από Διάρρηξη Σωληνώσεων
    "EKSODA_ADLHSHS_NERWN": {},
    "e01ae05f2d80138a8857bb669e27460c": {}, // Κόστος διερευνητικών εργασιών
    "6a9470f564b582fbe239e8c64051c927": {}  // Ζημιές στις ίδιες τις σωληνώσεις
  },
  "0003da5b2bf2adf55efc55a9f7cf2aad": {},   // Κατάρρευση, καθίζηση, κατολίσθηση
  "3d1207c0700c95ab3abe05c1f5063998": {},   // Α.Ε. όμορων κτιρίων
  "3358763f8560d5adcd015708d9e8f730": {},   // Αποκομιδή ερειπίων
  "90c8b86466111dfc1fbd98c9740b2717": {},   // Κάλυψη σε αξία καινούργιου
  "a75d81780cb669e6eed22aecb535e77c": {},   // Έξοδα Μηχανικών και Έκδοσης Αδειών
  "1d318e18005d48bad43190f517c490a7": {},   // Τιμαριθμική αναπροσαρμογή
  "617322208f4fdf1e7065878b0cbc059f": {},   // Πρόσκρουση οχήματος
  "52032a6b1d9b791f2042714608dfde74": {     // Ευρεία έκρηξη
    "eeacd7b782e7c14d565059f148446fa4": {}  // Ίδιες ζημίες έκρηξη λέβητα
  },
  "323539982047735a97f2956262e246c7": {},   // Προστασία από υπασφάλιση
  "7bcee15834e1e10329b945e22ca00d30": {},   // Κάλυψη δόσεων στεγαστικού δανείου
  "bbd68a59ef5cf34be5e3282c86077a0a": {},   // Βραχυκύκλωμα
  "46722d9fb5d8d24d2e62b8c5361004bd": {},   // Πτώση αεροσκαφών
  "ASFALISI_ZWHS": {},
  "THERAPEIES_LOGOU_OMILIAS_KAI_MATHISIS": {},
  "NOSHLEIA_KAT_OIKON": {},
  "CHECK_UP": {},
  "FYSIOTHERAPEIES": {},
  "DIATROFOLOGOI_DIAITOLOGOI": {},
  "EPEIGONTA_PERISTATIKA": {
    "kliniki_episkepsi": {},
    "diagnwstikes_eksetaseis_epeigon": {}
  },
  "AIMOLIPSIA_KAT_OIKON": {},
  "ENALLAKTIKH_OLISTIKH_IATRIKH": {},
  "OFTHALMOLOGIKH_KALYPSI": {},
  "DIAGNWSTIKES_EKSETASEIS": {
    "XWRIS_XRHSH_EOPYY": {},
    "ME_XRHSH_EOPYY": {}
  },
  "ODODIATRIKH_KALYPSH": {},
  "13776bbca037c5f6e63caeab159e1dfc": {},   // Αερόσακοι
  "dc6993ab47b08f019713bc61f8104ee5": {},   // Ζώνες ασφαλείας
  "EKTIMHSH_ZHMIWN": {},
  "KATHARISMOS_LOGW_METAFORAS_TRAVMATIA": {},
  "OIKOSKEVH": {},
  "5aaa8936e2211a190c1231b49eb73419": {},   // Εγγύηση Αξίας
  "bca97b7684fdb27770b9b80790992256": {},   // Ιατρικές Συμβουλές
  "5aec3226c5fabd11fac3aeb6547898f4": {},   // Ζημιές από λανθασμένο καύσιμο
  "9ab981e81fe79334cfe42f77340aaef4": {},   // Απώλεια, κλοπή εγγράφων
  "PROSTASIA_PALAIOTHTAS_ANTALLAKTIKWN": {},
  "0f6f83b4699b55257b22621a6a066a8a": {},   // Απαλλαγή πληρωμής ασφαλίστρων
  "5b283396c85fb810f43517ba47b43ff2": {},   // Κάρτα πρόληψης υγείας
  "e447fc4548de96dbafd8b2cb556ed786": {},   // Θαλάσσια Ρύπανση
  "4acdb1a59ec6dc395afb2ecef442b712": {},   // Απώλεια ενοικίων
  "ee690a8ac279f1d5f9432c22e76dd8be": {},   // Ληστεία Χρημάτων (Hold Up)
  "9647a14bddb6c01420b4cb45aab65340": {},   // Αστική Ευθύνη προς Τρίτους από καλυπτόμενους κινδύνους
  "286c72d5526ace72262542964080388e": {},   // Όρος Πρόνοιας
  "1c4a5a90963a68a9553ac2c67bfda340": {},   // Έξοδα ελαχιστοποίησης ζημιάς
  "56b706842126495569a8d5e9d8cde5ca": {},   // Ζημιές ηλιακού θερμοσίφωνα
  "e275ac404f5a9ea7e8522f710f747f8b": {},   // Αστική Ευθύνη προς Τρίτους από Διαρροή Ύδατος
  "psyxologiki_yposthriksh": {},
  "TIMH": {},
  "YGEIONOMIKH_METAFORA_KAI_AEROMETAFORA": {},
  "YPERASPISH_SE_POINIKA_DIKASTHRIA": {},
  "6342719707a86180b20f261ec8f7ff1a": {},   // Νομικές Συμβουλές
  "DIAFORES_APO_ASFALISTHRIA_SYMBOLAIA": {},
  "DIAFORES_APO_ENOXIKES_SYMBASEIS": {},
  "DIEKDIKHSEIS_APOZHMIWSEWN": {},
  "DIENERGEIA_PRAGMATOGNWMOSYNHS": {},
  "PROGENNHTIKOS_ELENXOS": {},
  "e42971c01c2f74cb88848dc822f68a57": {},   // Έξοδα εναλλακτικής μεταστέγασης
  "005ce913a0d26097c618d635ea893ec3": {},   // Αντικατάσταση Εγγράφων
  "be21e74d971d83441b52418e27052cfe": {},   // Επίδομα συνεπεία Πυρκαγιάς του οχήματος
  "ad2709e382075abf8451f53434969211": {},   // Έξοδα φύλαξης
  "5f3a93b823eb561ecb8743fe4decbcea": {},   // Επίδομα λόγω πυρκαγιάς ή ολικής κλοπής
  "DWREAN_IATRIKO_CHECK_UP": {},
  "EKSODA_DHMOSIWN_ARXWN": {},
  "00a5b2288e44e9e7af682994262773bd": {},   // Θραύση κρυστάλλων καθρεπτών
  "Prostasia_apo_mi_simvato_i_nothevmeno_kaysimo": {},
  "a039e1e6e02552c6f2c706203d848bba": {},   // Μη θεωρημένη άδεια οδήγησης
  "ALLOIWSH_TROFIMWN": {},
  "36b5cce1795fa8beb4f249b326a60f0b": {     // Οικοσκευή εκτός κατοικίας
    "92f3839322418816ee8b26f8b8d3e986": {}, // Ζημιές κατά τη μεταφορά
    "EKSODA_METAFORAS_OIKOSKEYHS": {}
  },
  "Zimies_antikeimenwn_pou_vriskontai_stin_eksoteriki_ple": {},
  "OIKOGENEIAKH_ASTIKH_EYTHYNH": {},
  "DIAMONH_SE_KSENODOXEIO": {},
  "5f786e4d2d0211387ae407779605d8c7": {},  // Έξοδα διερευνητικών εργασιών
  "Kalipsi_koinoxriston_solinon_kai_egkatastaseon": {},
  "iatrikes_praxeis": {},
  "AISTHITIKI_IATRIKI": {},
  "4e89391bd6a12485c04aaaa27d726f9a": {},  // Φροντίδα Αποζημίωσης
  "094b658d459c06f5cc48788e3bce9db1": {},  // Αντικατάσταση κρυστάλλου εξωτερικού καθρέπτου
  "Astiki_efthini_synepeia_sympliromatikon": {},
  "b1d9ad345a26014766ea3f18f3b54cb4": {},  // Αποζημίωση εκτός φιλικού διακανονισμού
  "b1f2cf77683a86bda4dcae4fd13af5b0": {},  // Παροχή Νομικών Συμβουλών & Εξωδικαστικού Συμβιβασμού
  "64079c1c78e05cdd35a574192dded429": {},   // Παροχές Υγείας
  "9311b8257b1709065f1c7a2d20ab269c": {},   // Safe ride home
  "88888888888888888888888888888888": {},   // Φυσικά Φαινόμενα Light
}

const checkDependentCoversModel = {
  "662f3c11b81157d3c636a29d579a9d7b":  [     // Ζημιές από Χαλάζι
    "ec0aa33177ee6f89e2744928148e9217",      // Φυσικά φαινόμενα
  ]
}

const uncheckDependentCoversModel = {
  "ec0aa33177ee6f89e2744928148e9217":  [     // Φυσικά φαινόμενα
    "662f3c11b81157d3c636a29d579a9d7b",      // Ζημιές από Χαλάζι
  ]
}

export { coversModel, checkDependentCoversModel, uncheckDependentCoversModel };
